import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { seguridadDAModulo } from 'src/app/aplicaciones-modulos/seguridadDA/diccionarios/seguridadDAModule';

@Injectable({
  providedIn: 'root'
})
export class OnlyControlService {

  diccionarioUrl: any;
  urlOnlyControl: string;
  
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlOnlyControl = this.utilServices.getComedor();
    this.diccionarioUrl = seguridadDAModulo.url.onlyControl;
  }

  uodatePhotoDA(area: string, localidad: string, empleado: string) {
    //console.log(this.urlOnlyControl + this.diccionarioUrl.updateFoto + area + '/' + localidad +'/'+ empleado);
    return this.commom.peticionPostConHeader(this.urlOnlyControl + this.diccionarioUrl.updateFoto + area 
        + '/' + localidad +'/'+ empleado, null);
  }

  getStatusPhotoDA() {
    //console.log(this.urlOnlyControl + this.diccionarioUrl.updateFoto + area + '/' + localidad +'/'+ empleado);
    return this.commom.peticionGetConHeader(this.urlOnlyControl + this.diccionarioUrl.syncPhotoStatus);
  }
}
